import { gql } from '@apollo/client';
import { GqlProgram, GqlProgramFragment, GqlProgramWithSeasonsFragment } from '../fragments/program';

export interface Data {
  programs: Array<GqlProgram>;
}

export interface Variables {
  organizationId: number;
}

export const QUERY = gql`
  query Programs($organizationId: Int!) {
    programs(organizationId: $organizationId) {
      ...ProgramFields
    }
  }
  ${GqlProgramFragment}
`;

export const QUERY_WITH_SEASONS = gql`
  query Programs($organizationId: Int!) {
    programs(organizationId: $organizationId) {
      ...ProgramWithSeasons
    }
  }
  ${GqlProgramWithSeasonsFragment}
`;
